export const iconFontAwesomeMapsLayerGroup = (
	<i className="fa-solid fa-layer-group"></i>
);
